// src/services/entityReports.js
import { adminPatch } from '../config/api';

const encode = (value) => encodeURIComponent(value ?? '');

export const updateEntityReportStatus = (type, entityId, payload = {}) =>
    adminPatch(`/entity-reports/${encode(type)}/${encode(entityId)}/status`, payload);
